import React from "react";
import PropTypes from "prop-types";
import Form from "../Form/form";
import {controlPropTypes} from "../formhelpers";

class GridRow extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        const selector = `control-container-${descriptor.key}`;
        return (
            <tr
                id={descriptor.id}
                className={`${selector} control-layout-gridrow`}
            >
                <Form {...this.props} />
            </tr>
        );
    }
}

GridRow.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

GridRow.propTypes = {
    ...controlPropTypes(null, false, true),
    propsResolver: PropTypes.func.isRequired,
    onCommitChange: PropTypes.func, // not required
};

export default GridRow;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Layout/gridrow.js